import { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { GroupTraining, GroupTrainingLedgerSearchForm } from 'entities/group_training'
import { useFetchGroupTrainingLedgerApi } from 'api/group_training_ledger'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useForm } from 'utils/hooks'
import { Pagination } from 'components/shared/pagination'
import { EditAttendInfoForm, EditGroupTrainingForm, NewGroupTrainingForm } from './group_training_form'
import { useState } from 'react'
import { ActionTableCell, ExTable, TableBody, TableCell, TableHead, TableWrapper } from 'components/shared/widget'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { IoCreateOutline, IoNewspaperOutline, IoSchoolSharp } from 'react-icons/io5'
import { groupTrainingLedgerColumnInfoList, GroupTrainingLedgerTableData } from './group_training_table'
import { SearchConditionView } from 'components/shared/search_drawer'
import { setPageSize } from 'utils/util'

type Props = {
    history: H.History
}

const GroupTrainingPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const searchForm = useForm<GroupTrainingLedgerSearchForm>({ ordering: '-group_training_ledger_date' })
    const listApi = useFetchGroupTrainingLedgerApi(searchForm)

    const [showEditGroupTraining, setShowEditGroupTraining] = useState<boolean>(false)
    const [showEditAttendInfo, setShowEditAttendInfo] = useState<boolean>(false)
    const groupTrainingLedgerDisplaySetting = useDisplaySetting(groupTrainingLedgerColumnInfoList(searchForm), 'groupTraining')
    const [selectedGroupTrainingLedger, setSelectedGroupTrainingLedger] = useState<GroupTraining>({})

    useEffect(() => {
        listApi.execute()
        setPageSize('portrait')
    }, [])

    const handleClickRemoveFilter = (key: keyof GroupTrainingLedgerSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    return (
        <>
            <ContentHeader
                headerTitle="集合教育記録台帳"
                left={
                    <>
                        <NewGroupTrainingForm onComplete={() => listApi.execute()} />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={
                    <>
                        <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                    </>
                }
            />
            <ContentBody>
                <TableWrapper>
                    <EditGroupTrainingForm
                        show={showEditGroupTraining}
                        groupTraining={selectedGroupTrainingLedger}
                        onClose={() => setShowEditGroupTraining(false)}
                        onComplete={() => {
                            setShowEditGroupTraining(false)
                            listApi.execute()
                        }}
                    />
                    <EditAttendInfoForm
                        show={showEditAttendInfo}
                        groupTraining={selectedGroupTrainingLedger}
                        onClose={() => setShowEditAttendInfo(false)}
                        onComplete={() => {
                            setShowEditAttendInfo(false)
                            listApi.execute()
                        }}
                    />
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <TableHeads displaySetting={groupTrainingLedgerDisplaySetting} />
                                <TableCell th width={35} align={'center'}>
                                    台帳
                                </TableCell>
                                <TableCell th width={140} align={'center'}>
                                    受講情報編集
                                </TableCell>
                                <TableCell th width={140}>
                                    講習会情報編集
                                </TableCell>
                            </tr>
                        </TableHead>
                        <TableBody loading={listApi.loading}>
                            {listApi.response.results.map((groupTraining: GroupTraining) => {
                                return (
                                    <tr key={groupTraining.id}>
                                        <GroupTrainingLedgerTableData groupTraining={groupTraining} displaySetting={groupTrainingLedgerDisplaySetting} />
                                        <ActionTableCell
                                            action="other"
                                            onClick={() => {
                                                props.history.push('/ledger/group_training_ledger', { groupTraining: groupTraining })
                                            }}
                                        >
                                            <IoNewspaperOutline size={14} />
                                        </ActionTableCell>
                                        <ActionTableCell
                                            action={'other'}
                                            onClick={() => {
                                                setSelectedGroupTrainingLedger(groupTraining)
                                                setShowEditAttendInfo(true)
                                            }}
                                        >
                                            <IoSchoolSharp size={14} />
                                        </ActionTableCell>
                                        <ActionTableCell
                                            action={'other'}
                                            onClick={() => {
                                                setSelectedGroupTrainingLedger(groupTraining)
                                                setShowEditGroupTraining(true)
                                            }}
                                        >
                                            <IoCreateOutline size={18} />
                                        </ActionTableCell>
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(GroupTrainingPage)
